<!-- <style>

    .widgets {
        position: absolute;
        z-index: 2;
    }

</style>

<div class="widgets">
    <div><div class="sr-widget sr-widget-1"></div></div>

</div> -->
<section class="events-main-wrap" *ngIf="eventsGroupVM">

    <section class="events-wrap">
        <div class="selected-league" *ngIf="eventsGroupVM.events.length > 0">
            <ng-container *ngFor="let event of eventsGroupVM.events; let i = index">
                <ng-container *ngIf="i==0 || eventsGroupVM.events[i-1].dateTime.getDate() != event.dateTime.getDate() || (viewConfigurations.showAllEventsButtonOnSelectedRegion && eventsGroupVM.regionId && !eventsGroupVM.competitionId && eventsGroupVM.events[i-1].competitionId != eventsGroupVM.events[i].competitionId)">
                    <div class="row bet-type-name-wrap">
                        <div class="col col1"></div>
                        <div class="col col2" *ngIf="eventsGroupVM.specialOfferType != specialOfferTypeEnum.Outrights">
                            <ng-container *ngFor="let betTypeGroupingTemplateItem of selectedBetTypeGroupingTemplateItems; let i = index">
                                <div class="bet-type-col" title="{{betTypeGroupingTemplateItem.betTypeDescription}}">
                                    {{betTypeGroupingTemplateItem.betTypeName}}
                                    <!-- <i title="{{betTypeGroupingTemplateItem.betTypeDescription}} test2" class="icon icon-ex-sm s-icon-sporticon-error"></i> -->
                                </div>

                            </ng-container>
                        </div>
                        <div class="col col-bets"></div>
                    </div>

                    <div class="row bet-info-wrap">
                        <div class="col col1">
                          <span class="competition-name" *ngIf="viewConfigurations.showAllEventsButtonOnSelectedRegion && eventsGroupVM.regionId && !eventsGroupVM.competitionId">{{event.competitionName}}</span>
                          <span>{{event.eventDate}}</span>
                        </div>
                        <div class="col col2" *ngIf="eventsGroupVM.specialOfferType != specialOfferTypeEnum.Outrights">
                            <ng-container *ngFor="let betTypeGroupingTemplateItem of selectedBetTypeGroupingTemplateItems; let i = index">
                                <div class="bet-type-col">
                                    <ng-container *ngFor="let betTypeOutcome of betTypeGroupingTemplateItem.betTypeOutcomes; let k = index">
                                        <ng-container *ngIf="k<3">
                                            <span class="sbv" *ngIf="betTypeGroupingTemplateItem.sbvDisplayType != sbvDisplayTypeEnum.NoSbv && (k==0 && betTypeGroupingTemplateItem.betTypeOutcomes.length > 2 || k==1 && betTypeGroupingTemplateItem.betTypeOutcomes.length < 3)"></span>
                                            <span>{{betTypeOutcome.name}}</span>
                                        </ng-container>
                                    </ng-container>

                                </div>

                            </ng-container>
                        </div>

                        <div class="col col-bets"></div>
                    </div>

                </ng-container>
                <app-event [pageType]="pageType" [event]="event" [betsAndOutcomes]="betsAndOutcomesForEvents ? betsAndOutcomesForEvents[event.id] : {}" [betTypeGroupingTemplateItems]="selectedBetTypeGroupingTemplateItems"></app-event>

            </ng-container>

        </div>
    </section>
</section>
